export type ItemListBox = {
    label: string;
    icon: string;
    method: () => void;
};

export type ApiError ={
    status: string;
    title: string;
    detail: string;
}

export type RecursivePartial<T> = {
    [P in keyof T]?: RecursivePartial<T[P]>;
};

export type ItemTag = {
    id: string;
    label: string;
    selected: boolean;
    opened: boolean;
    itemTagColors?: ItemTagColors;
    appointmentTypeDoctorId?: string;
}

export type ItemTagColors = {
    textColor: string;
    disabledTextColor: string;
    backgroundColor: string;
    disabledBackgroundColor: string;
}

export type ItemSelect = {
    id: string;
    label: string;
    icon?: string;
    iconFolder?: string;
}

export type ItemSelectPatient = {
    id: string;
    label: string;
    birthdate: string;
    serialNumber: string;
}

export type ItemButtonGroup = {
    codeAction?: string;
    icon: string;
    pathIcon: string;
    // eslint-disable-next-line @typescript-eslint/ban-types
    method?: Function;
}

export enum ButtonAction {
    REDIRECT_FOLDER = 'REDIRECT_FOLDER',
    REDIRECT_CALENDAR = 'REDIRECT_CALENDAR',
    ADD = 'add'
}

export enum DateFormat {
    FIRST_DAY_ISO_SMALL = 'yyyy-MM-01',
    ISO_SMALL = 'yyyy-MM-dd',
    ISO_LONG = 'yyyy-MM-dd HH:mm',
    ISO_FULL = "yyyy-MM-dd'T'HH:mm:ss",
    TIME_SMALL = 'HH:mm',
    TIME_LONG = 'HH:mm:ss',
    DATEPICKER = 'dd/mm/yy',
    FRONT_LONG = 'dd/MM/yyyy',
    FRONT_LETTER = 'd MMMM yyyy',
    FRONT_DAY = 'dd',
    FRONT_MONTH_YEAR_LETTER = 'MMMM yyyy',
    FRONT_FULL = 'eeee d MMMM yyyy',
    TIME_FR_LONG = 'kk:mm:ss',
    TIME_FR_SMALL = 'kk:mm',
    DATE_TIME_FR_SMALL = 'dd/MM/yyyy kk:mm',
    TIME_WITH_OFFSET = 'HH:mmxxx'
}

export enum LocaleCode {
    FR = 'fr'
}

export enum PatientStatus {
    WAITING = 'WAITING',
    LEAVE = 'LEAVE',
    OUT = 'OUT'
}

export enum ScheduleStatus {
    OFFLINE = 'OFFLINE',
    ONLINE = 'ONLINE',
    PATIENT = 'PATIENT'
}
export const Regex = {
  emailFormat: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  number: /^\d+$/,
  wildcardPostgre: /[%_]/,
  numberWithSpaces: /^[0-9 ]+$/
}

export enum LocalRegion {
    frFR = 'fr-FR'
}

export const DURATION_VALUES = [5, 10, 15, 20, 30] as const;

export enum RANGE  {
    RANGE = 'range',
    SINGLE = 'single'
}

export const categoryLabels = {
  'LeftMenu': 'Menu principal (bleu)',
  'PatientRecord': 'Patient - Dossier médical',
}


export enum PersonWithRoleStatus  {
    HealthPro = 'HealthPro',
    HealthProAssistant = 'HealthProAssistant',
    HealthProStudent = 'HealthProStudent',
    CustomPatient = 'CustomPatient',
    CustomLearningSpeaker = 'CustomLearningSpeaker'
}

export enum PersonWithRoleStatusAdminInstitute {
    HealthPro = 'HealthPro',
    Admin = 'Admin'
}

export enum MedicalPersonRoleStatus {
    HealthPro = 'HealthPro',
    HealthProAssistant = 'HealthProAssistant',
    HealthProStudent = 'HealthProStudent'
}

export enum SctLanguage {
    EnUs = 'EnUs', 
    EnGb = 'EnGb', 
    FrFr = 'FrFr',
    DeDe = 'DeDe',
    EsEs = 'EsEs'
}

export enum SctLanguageItem {
    EnUs = 'Us', 
    EnGb = 'Gb', 
    FrFr = 'Fr',
    DeDe = 'De',
    EsEs = 'Es'
}

export const SctLanguageSelect: Record<SctLanguage, { id: string; label: string }> = {
  [SctLanguage.EnUs]: { id: SctLanguageItem.EnUs, label: SctLanguage.EnUs },
  [SctLanguage.EnGb]: { id: SctLanguageItem.EnGb, label: SctLanguage.EnGb },
  [SctLanguage.FrFr]: { id: SctLanguageItem.FrFr, label: SctLanguage.FrFr },
  [SctLanguage.DeDe]: { id: SctLanguageItem.DeDe, label: SctLanguage.DeDe },
  [SctLanguage.EsEs]: { id: SctLanguageItem.EsEs, label: SctLanguage.EsEs },
};

export enum Gender {
    NONE = 'NONE',
    MALE = 'MALE',
    FEMALE = 'FEMALE',
    NON_BINARY = 'NON_BINARY'
}

export type ItemSelectPhone = {
    id: string;
    label: string;
    prefix: string;
}

export enum IsoCode  {
    LU = 'LU'
}

export type UpdateItemName = {
    itemUuid : string;
    name: string;
}

export enum prefixPhone {
    LU = '352'
}

enum TaskChannelTypeEnum {
  None = "None",
  TwoPerson = "TwoPerson",
  Results = "Results"
}

export const apiToEnumMap: Record<string, TaskChannelTypeEnum> = {
  NONE: TaskChannelTypeEnum.None,
  TWO_PERSON: TaskChannelTypeEnum.TwoPerson,
  RESULTS: TaskChannelTypeEnum.Results,
};

export const PageableDefault = {
    limit: 20,
    start: 0
}

export const SmallPageableDefault = {
    limit: 10,
    start: 0
}

export const MIDNIGHT_TIME_CALENDAR = "24:00:00";
export const MIDNIGHT_TIME = "00:00:00";
export const MIDNIGHT_TIME_SHORT = "00:00";

export const PageableDefaultForUserAppointments = {
    limit: 10,
    start: 0
}

export const BadgeSeverity = {
    "Secondary": "secondary",
    "Info": "info",
    "Success": "success",
    "Warn": "warn",
    "Danger": "danger",
    "Contrast": "contrast",
}
